<template>
  <div :class="$style.container">
    <ModalStructure
      :class="$style.modal"
      :data-test-id="$testId('configuredAppsModalStructure')"
      shouldCloseOnBlur
      showCloseButton
      showModal
      @close="handleClose"
    >
      <template v-slot:header>
        <HeadingSmall>{{ modalHeading }}</HeadingSmall>
      </template>

      <template v-slot:body>
        <ParagraphBody>{{ modalDescription }}</ParagraphBody>

        <div :class="$style.appCardsContainer">
          <div
            v-for="app in applications"
            :key="app.id"
            aria-label="click to go to this application's details page"
            :class="$style.cardWrapper"
            title="Click to go to this application's details page"
            @click="handleAppCardClick(app.id)"
          >
            <img
              :class="$style.logo"
              :src="app.logoUrl"
            >

            <ParagraphBody
              :class="$style.displayLabel"
              weight="semibold"
            >
              {{ app.displayLabel }}
            </ParagraphBody>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div :class="$style.footerContainer">
          <IconButton
            ariaLabel="create new application button"
            :data-test-id="$testId('createNewApplicationButton')"
            hasOutline
            icon="add"
            text="create new application"
            type="secondary"
            @click="handleCreateNewButtonClick"
          />
        </div>
      </template>
    </ModalStructure>
  </div>
</template>

<script>
import {
  HeadingSmall,
  IconButton,
  ModalStructure,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'ConfiguredAppsDetectedModal',

  components: {
    HeadingSmall,
    IconButton,
    ModalStructure,
    ParagraphBody,
  },

  props: {
    appDisplayName: {
      type: String,
      default: '',
    },

    applications: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    hasMoreThanOneApp() {
      return this.applications.length > 1;
    },

    modalDescription() {
      return this.hasMoreThanOneApp
        ? `Do you want to use one of your configured ${this.appDisplayName} integrations or create a new one?`
        : `Do you want to use your configured ${this.appDisplayName} integration or create a new one?`;
    },

    modalHeading() {
      return `Configured Application${this.hasMoreThanOneApp ? 's' : ''} Detected`;
    },
  },

  methods: {
    handleAppCardClick(appId) {
      this.$router.push(`/sso/${appId}/details`);
    },

    handleClose() {
      this.$emit('close');
    },

    handleCreateNewButtonClick() {
      this.$emit('continue');
    },
  },
};
</script>

<style module scoped>
.appCardsContainer {
  max-height: 270px;
}

.cardWrapper {
  align-items: center;
  border: 1px var(--jc-color-neutral-stroke) solid;
  border-radius: 4px;
  column-gap: 50px;
  cursor: pointer;
  display: flex;
  height: 90px;
  width: 100%;
}

.cardWrapper:not(:last-of-type) {
  margin-bottom: var(--jc-spacer);
}

.container {
  text-align: left;
}

.displayLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footerContainer {
  margin-left: auto;
  margin-right: 0;
}

.logo {
  height: auto;
  margin-left: var(--jc-spacer-medium);
  width: 80px;
}

.modal {
  --modal-width: 550px;
}

.modal >>> .ModalContentStructure__footer {
  padding-top: 0;
}
</style>
